import HeaderMain from "../comp/head-navs-main";
import ViewContent from "../comp/view-content";
import ViewDividerSmall from "../comp/view-divider-sm";
import ViewDividerMedium from "../comp/view-divider-md";
import ViewSectionName from "../comp/view-section-name";

import UserBalanceCard from "../comp/user-balancecard";
import UserScoreCard from "../comp/user-score-card";
import UserTasksListModule from "../comp/user-tasks-list";
import MarketOffersListModule from "../comp/mrkt-offers-list";

export default function Home() {


  return (
    <>
      <HeaderMain />
      <ViewContent 
        content={
          <>
            <ViewDividerSmall />
            <UserBalanceCard />
            <ViewDividerSmall />
            <UserScoreCard />

            <ViewDividerMedium />            
            <ViewSectionName data={'My Actions'}/>
            <UserTasksListModule />

            <ViewDividerMedium />            
            <ViewSectionName data={'New Courses'}/>
            <MarketOffersListModule data={"medical"}/>

            <ViewDividerMedium />
            <ViewDividerMedium />
          </>
        }
      />
      

    </>
  )
}